import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Tooltip } from '@chegg-ui/tooltip';
import { tagFunnel } from '../actions/tagmanager';
import { convertToFile } from '../actions/upload';
import { CHECK_MY_PAPER, TEXT_FIELD } from '../util/dataTestIds';
import { collectRioEvent } from '../actions/rio';
import { redirectToDemo } from '../actions/redirect';
import { CheckPaperButton, PastePaperTextArea, DocumentTextAreaContainer, DemoText, TextAreaWrapper, TooltipWrapper } from '../styles';
import { PASTE_PAPER_COPY, CHECK_MY_PAPER_BUTTON_COPY, DEMO_LINK_COPY, DEMO_LINK_TOOLTIP_COPY } from '../constants';
import { ORIGINS } from '../analytics/constants';
export var DocumentText = function DocumentText(_ref) {
  var showDemoLink = _ref.showDemoLink,
    onCreateText = _ref.onCreateText,
    onDemoLinkClick = _ref.onDemoLinkClick,
    onDemoLinkHover = _ref.onDemoLinkHover,
    initialized = _ref.initialized,
    initialCollapsed = _ref.initialCollapsed,
    buttonAttributes = _ref.buttonAttributes,
    onEnterText = _ref.onEnterText,
    onCtaActivated = _ref.onCtaActivated,
    onCtaClicked = _ref.onCtaClicked,
    demoTextEnabled = _ref.demoTextEnabled,
    isResubmit = _ref.isResubmit,
    filename = _ref.filename;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    text = _React$useState2[0],
    setText = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    textEntered = _React$useState4[0],
    setTextEntered = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isSubmitDisabled = _React$useState6[0],
    setIsSubmitDisabled = _React$useState6[1];
  var _React$useState7 = React.useState(initialCollapsed),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    collapsed = _React$useState8[0],
    setCollapsed = _React$useState8[1];
  var textAreaHeight = collapsed ? '80px' : '200px';
  var demoTextAreaHeight = collapsed ? '40px' : '160px';
  var height = demoTextEnabled ? demoTextAreaHeight : textAreaHeight;
  var handleChange = function handleChange(value) {
    if (!textEntered) {
      onEnterText && onEnterText();
      setTextEntered(true);
    }
    setText(value);
  };
  var handleDemoLinkClick = function handleDemoLinkClick(e) {
    e.preventDefault();
    onDemoLinkClick();
  };
  var handleClick = function handleClick() {
    onCtaClicked && onCtaClicked();
    onCreateText(text, isResubmit, filename);
  };
  useEffect(function () {
    showDemoLink();
  }, []);
  useEffect(function () {
    if (initialized) {
      var hasMinText = text.trim().length >= 50;
      if (isSubmitDisabled && hasMinText) {
        onCtaActivated && onCtaActivated();
        setIsSubmitDisabled(false);
      } else if (!isSubmitDisabled && !hasMinText) {
        setIsSubmitDisabled(true);
      }
    }
  }, [text, initialized]);
  return /*#__PURE__*/React.createElement(DocumentTextAreaContainer, {
    className: "uw__textarea-container"
  }, /*#__PURE__*/React.createElement(TextAreaWrapper, {
    className: "uw__textarea-wrapper"
  }, /*#__PURE__*/React.createElement(PastePaperTextArea, {
    className: "uw__textarea",
    inputId: "paste-paper-text-area",
    name: "paste-paper",
    labelText: PASTE_PAPER_COPY,
    height: height,
    placeholder: PASTE_PAPER_COPY,
    onChange: handleChange,
    onClick: function onClick() {
      return setCollapsed(false);
    },
    rows: 15,
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: false,
    "data-test-id": TEXT_FIELD,
    "aria-label": PASTE_PAPER_COPY
  }), demoTextEnabled && /*#__PURE__*/React.createElement(TooltipWrapper, null, /*#__PURE__*/React.createElement(Tooltip, {
    position: "top",
    targetElement: /*#__PURE__*/React.createElement(DemoText, {
      onMouseEnter: onDemoLinkHover,
      onClick: handleDemoLinkClick
    }, "Check out our demo page")
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "<div>See how it works</div>"
    }
  })))), /*#__PURE__*/React.createElement(CheckPaperButton, _extends({}, buttonAttributes, {
    className: "uw__check-paper",
    size: "large",
    onClick: handleClick,
    disabled: isSubmitDisabled,
    "data-id": "checkPaperButton",
    "data-test-id": CHECK_MY_PAPER,
    type: "submit"
  }), CHECK_MY_PAPER_BUTTON_COPY));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCreateText: function onCreateText(text, isResubmit, filename) {
      dispatch(convertToFile(text, isResubmit, filename));
      dispatch(tagFunnel('upload paper', 'copy and paste'));
    },
    showDemoLink: function showDemoLink() {
      return dispatch(collectRioEvent(ORIGINS.DEMO_LINK_VIEW, {
        text: DEMO_LINK_COPY
      }));
    },
    onDemoLinkHover: function onDemoLinkHover() {
      return dispatch(collectRioEvent(ORIGINS.DEMO_LINK_HOVER, {
        text: DEMO_LINK_TOOLTIP_COPY
      }));
    },
    onDemoLinkClick: function onDemoLinkClick() {
      dispatch(collectRioEvent(ORIGINS.DEMO_LINK_CLICK, {
        text: DEMO_LINK_COPY
      }));
      dispatch(redirectToDemo());
    }
  };
};
export default connect(null, mapDispatchToProps)(DocumentText);